"use client";

import { PageLayout } from "@repo/dashboard-core";

import { PhoneCheckerView } from "@/components/phone-checker/PhoneCheckerView";

import { ServiceGuard } from "../_services/ServiceGuard";

export default function PhoneCheckerPage() {
  return (
    <PageLayout>
      <ServiceGuard>
        <PhoneCheckerView />
      </ServiceGuard>
    </PageLayout>
  );
}
